const features = [
  {
    icon: "ri-movie-2-line",
    tone: "primary",
    title: "海量多元内容",
    desc: "短视频、娱乐、生活多频道并行，每天都有新内容上线，兴趣永远有处安放。",
  },
  {
    icon: "ri-heart-3-line",
    tone: "accent",
    title: "轻松互动交流",
    desc: "点赞、收藏、评论一键完成，你的每一次表达都会被社区看见。",
  },
  {
    icon: "ri-upload-cloud-2-line",
    tone: "secondary",
    title: "人人都能分享",
    desc: "零门槛上传流程，把你的作品与生活记录分享给更多同好。",
  },
];

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-600",
  accent: "bg-accent-100 text-accent-600",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function AboutSection() {
  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold">
            <i className="ri-star-smile-line" aria-hidden="true"></i>
            关于呱呱视频社区
          </span>
          <h2 className="mt-4 font-heading font-extrabold text-2xl md:text-3xl text-foreground-950">
            一个更懂内容，也更懂你的视频社区
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            我们相信好内容值得被更多人看到。呱呱视频社区把丰富的视频内容、简单的互动方式和友好的社区氛围放在一起，
            让观看、分享和交流都变得轻松自然。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {features.map((f) => (
            <div key={f.title} className="p-6 rounded-lg bg-background-50 border border-background-200">
              <span className={`w-12 h-12 flex items-center justify-center rounded-lg text-2xl ${toneMap[f.tone]}`}>
                <i className={f.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading font-semibold text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { value: "18+", label: "在架视频" },
            { value: "3", label: "内容分类" },
            { value: "99%", label: "用户好评" },
            { value: "7x24", label: "随时观看" },
          ].map((stat) => (
            <div key={stat.label} className="text-center py-4 rounded-lg bg-background-50 border border-background-200">
              <p className="font-heading font-extrabold text-2xl text-primary-600">{stat.value}</p>
              <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}